// This file is auto-generated by @hey-api/openapi-ts

import type { DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse, DirectoutreachPolicyAvailableListResponse, DirectoutreachPolicyAvailableRetrieveResponse, DirectoutreachPolicyCreateResponse, DirectoutreachVotersCreateCreateResponse, DirectoutreachVotersHoldingsRetrieveResponse, DirectoutreachVotersSelectedPolicyCreateResponse, DirectoutreachVotersSelectedPolicyRetrieveResponse, InstitutionalMeetingsearchListResponse, ProxyvotingPiballotsFilterListResponse, ProxyvotingPimeetingsFilterListResponse, ProxyvotingSviProposalOverwriteCreateResponse } from './types.gen';

const exportResultSchemaResponseTransformer = (data: any) => {
    data.exported_at = new Date(data.exported_at);
    return data;
};

export const directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer = async (data: any): Promise<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse> => {
    data = exportResultSchemaResponseTransformer(data);
    return data;
};

const policySchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

export const directoutreachPolicyCreateResponseTransformer = async (data: any): Promise<DirectoutreachPolicyCreateResponse> => {
    data = policySchemaResponseTransformer(data);
    return data;
};

const policyResponseSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

export const directoutreachPolicyAvailableListResponseTransformer = async (data: any): Promise<DirectoutreachPolicyAvailableListResponse> => {
    data = data.map((item: any) => policyResponseSchemaResponseTransformer(item));
    return data;
};

export const directoutreachPolicyAvailableRetrieveResponseTransformer = async (data: any): Promise<DirectoutreachPolicyAvailableRetrieveResponse> => {
    data = policyResponseSchemaResponseTransformer(data);
    return data;
};

const holdingSchemaResponseTransformer = (data: any) => {
    data.valid_time = new Date(data.valid_time);
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

const holdingResponseSchemaResponseTransformer = (data: any) => {
    data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item));
    return data;
};

export const directoutreachVotersHoldingsRetrieveResponseTransformer = async (data: any): Promise<DirectoutreachVotersHoldingsRetrieveResponse> => {
    data = holdingResponseSchemaResponseTransformer(data);
    return data;
};

const selectedPolicySchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

const selectedPolicyResponseSchemaResponseTransformer = (data: any) => {
    if (data.selectedPolicy) {
        data.selectedPolicy = selectedPolicySchemaResponseTransformer(data.selectedPolicy);
    }
    return data;
};

export const directoutreachVotersSelectedPolicyRetrieveResponseTransformer = async (data: any): Promise<DirectoutreachVotersSelectedPolicyRetrieveResponse> => {
    data = selectedPolicyResponseSchemaResponseTransformer(data);
    return data;
};

export const directoutreachVotersSelectedPolicyCreateResponseTransformer = async (data: any): Promise<DirectoutreachVotersSelectedPolicyCreateResponse> => {
    data = selectedPolicyResponseSchemaResponseTransformer(data);
    return data;
};

const voterWithHoldingsResponseSchemaResponseTransformer = (data: any) => {
    data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item));
    return data;
};

export const directoutreachVotersCreateCreateResponseTransformer = async (data: any): Promise<DirectoutreachVotersCreateCreateResponse> => {
    data = voterWithHoldingsResponseSchemaResponseTransformer(data);
    return data;
};

const meetingSchemaResponseTransformer = (data: any) => {
    data.meeting_date = new Date(data.meeting_date);
    data.action_deadline = new Date(data.action_deadline);
    return data;
};

const paginatedMeetingListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingSchemaResponseTransformer(item));
    return data;
};

export const institutionalMeetingsearchListResponseTransformer = async (data: any): Promise<InstitutionalMeetingsearchListResponse> => {
    data = paginatedMeetingListSchemaResponseTransformer(data);
    return data;
};

const piBallotSearchSchemaResponseTransformer = (data: any) => {
    data.vote_deadline = new Date(data.vote_deadline);
    return data;
};

const paginatedPiBallotSearchListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => piBallotSearchSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingPiballotsFilterListResponseTransformer = async (data: any): Promise<ProxyvotingPiballotsFilterListResponse> => {
    data = paginatedPiBallotSearchListSchemaResponseTransformer(data);
    return data;
};

const piMeetingSearchSchemaResponseTransformer = (data: any) => {
    data.meeting_time = new Date(data.meeting_time);
    data.submission_deadline = new Date(data.submission_deadline);
    if (data.record_date) {
        data.record_date = new Date(data.record_date);
    }
    if (data.cancel_time) {
        data.cancel_time = new Date(data.cancel_time);
    }
    data.meeting_create_time = new Date(data.meeting_create_time);
    if (data.latest_valid_to_sii) {
        data.latest_valid_to_sii = new Date(data.latest_valid_to_sii);
    }
    return data;
};

const paginatedPiMeetingSearchListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => piMeetingSearchSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingPimeetingsFilterListResponseTransformer = async (data: any): Promise<ProxyvotingPimeetingsFilterListResponse> => {
    data = paginatedPiMeetingSearchListSchemaResponseTransformer(data);
    return data;
};

const splitVoteInstructionProposalOverwriteSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    if (data.delete_time) {
        data.delete_time = new Date(data.delete_time);
    }
    return data;
};

export const proxyvotingSviProposalOverwriteCreateResponseTransformer = async (data: any): Promise<ProxyvotingSviProposalOverwriteCreateResponse> => {
    data = splitVoteInstructionProposalOverwriteSchemaResponseTransformer(data);
    return data;
};
